import React, { Component } from 'react';
import DateUtil from '../../../../library/util/DateUtil';
import { Repeater, ItemContainer } from '../../../../library/repeater';
import OldEventListItem from './OldEventListItem';
import PostMoreListInjector from '../../../../library/board/PostMoreListInjector';
import Paging from '../../../common/components/Paging';
import { routes } from '../../../../constants/routes';
import { getQueryObjFromRouter } from '../../../../utils/miscUtils';

class OldEventListContainer extends Component {
  constructor(props) {
    super(props);

    this.onChangePage = this.onChangePage.bind(this);
  }

  componentDidMount() {
    const query = {
      ...this.props.history.query,
      ...getQueryObjFromRouter(this.props.history),
    };
    const { pageno = 1 } = query;
    this.getPostMoreList(pageno);
  }

  onChangePage(pageno) {
    let query = { ...this.props.history.query, pageno };
    this.getPostMoreList(pageno);
    this.props.history.push(`${routes.customer.event}?pageno=${pageno}`);
  }

  getPostMoreList(pageno) {
    const params = {
      data__event_info__end_date__lt: DateUtil.today(),
      status__ne: 2,
    };
    this.props.getPostMoreList(pageno, params);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.history.query) !==
      JSON.stringify(this.props.history.query)
    ) {
      const { pageno = 1 } = this.props.history.query;
      this.getPostMoreList(pageno);
    }
  }

  render() {
    const { postMoreList, pageSize } = this.props;
    const { pageno = 1 } = this.props.history.query;
    if (this.props.postMoreList.count === 0) {
      return null;
    }
    return (
      <section>
        <h4 className="no-margin">지난 이벤트</h4>
        <div className="dotted-list">
          <Repeater
            arrayData={postMoreList.postList.results}
            propName="postInfo"
            elementName="ul"
          >
            <ItemContainer>
              <OldEventListItem {...this.props} />
            </ItemContainer>
          </Repeater>
        </div>
        <Paging
          selected={parseInt(pageno, 10)}
          step={5}
          onClick={this.onChangePage}
          count={postMoreList.postList.count}
          pageSize={pageSize}
        />
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initLoad: false,
    history: ownProps.history,
  };
};

export default PostMoreListInjector(mapStateToProps)(OldEventListContainer);
